import { Button } from "../../../../shared/ui";

import type { FC } from "react";
import { getRouteVacancies } from "../../../../shared/constants/routes";
import { useLocation, useNavigate } from "react-router-dom";
import { SearchParamsVacancyEnum, DEFAULT_VACANCIES_TO_SHOW } from "../../../../shared/constants/searchParams";

import styles from "./NavigationVacancies.module.scss";

interface NavigationVacanciesProps {
    onClick?: () => void;
}

export const NavigationVacancies: FC<NavigationVacanciesProps> = ({ onClick }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const handleClick = () => {
        if (pathname === getRouteVacancies()) {
            navigate(`${getRouteVacancies()}?${SearchParamsVacancyEnum.TAKE}=${DEFAULT_VACANCIES_TO_SHOW}`, { replace: true });
        } else {
            navigate(getRouteVacancies());
        }
        
        onClick?.();
    };

    return (
        <Button as="button" onClick={handleClick} className={styles.button}>
            Все вакансии
        </Button>
    );
};
